import { HashRouter as Router, Route, Routes } from "react-router-dom";
import { useEffect } from "react";
import { ToastContainer } from "react-toastify";

import Home from "./components/Home";
import Cart from "./components/Cart";
import ProductList from "./components/ProductList";
import LoginRegister from "./components/LoginRegister";
import DoctorRegister from "./components/DoctorRegister";
import Logout from "./components/Logout";
import Checkout from "./components/Checkout";
import Myprofile from "./components/Myprofile";
import PaymentSuccess from "./components/PaymentSuccess";
import ProductDetail from "./components/ProductDetail";
import OrderSuccess from "./components/OrderSuccess";
import OrderBookingSuccess from "./components/OrderBookingSuccess";
import PrivicyPolicy from "./components/PrivicyPolicy";
import CancellationPolicy from "./components/CancellationPolicy";
import TermsCondition from "./components/TermsCondition";
import ShippingPolicy from "./components/ShippingPolicy";
import CategoryList from "./components/CategoryList";
import BrandList from "./components/BrandList";

import FrontDoctorList from "./components/FrontDoctorList";
import FrontDoctorDetails from "./components/FrontDoctorDetails";
import FrontDoctorBooking from "./components/FrontDoctorBooking";
import FrontBookingConfirmed from "./components/FrontBookingConfirmed";

import FrontClinicList from "./components/FrontClinicList";
import FrontClinicDetails from "./components/FrontClinicDetails";

import FrontTreatmentList from "./components/FrontTreatmentList";
import FrontTreatmentDetails from "./components/FrontTreatmentDetails";

import BlogList from "./components/BlogList";
import BlogDetail from "./components/BlogDetail";
import AboutUs from "./components/AboutUs";
import ContactUs from "./components/ContactUs";
import Wellness from "./components/Wellness";
import Faq from "./components/Front/Faq";

import "bootstrap/dist/css/bootstrap.min.css";
import './App.css';
import "react-toastify/dist/ReactToastify.css";

import HealthAwarenessCalendar from "./components/HealthAwarenessCalendar";
import CalendarPage from "./components/CalendarPage";
import Eventday from "./components/Eventday";
import EventDetail from "./components/EventDetail";


function loadAssets(files) {
  files.forEach(file => {
    if (file.endsWith(".css")) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = file;
      document.head.appendChild(link);
    } else if (file.endsWith(".js")) {
      const script = document.createElement("script");
      script.src = file;
      script.async = false;
      document.body.appendChild(script);
    }
  });
}

function FrontApp() {

  useEffect(() => {

    // ✅ ✅ GLOBAL TIMEZONE SET (Asia/Kolkata)
    const DEFAULT_TIMEZONE = "Asia/Kolkata";

    const originalToLocaleString = Date.prototype.toLocaleString;
    Date.prototype.toLocaleString = function (locale = "en-IN", options = {}) {
      return originalToLocaleString.call(this, locale, {
        timeZone: DEFAULT_TIMEZONE,
        ...options,
      });
    };

    const originalToLocaleTimeString = Date.prototype.toLocaleTimeString;
    Date.prototype.toLocaleTimeString = function (locale = "en-IN", options = {}) {
      return originalToLocaleTimeString.call(this, locale, {
        timeZone: DEFAULT_TIMEZONE,
        ...options,
      });
    };

    // ✅ Load assets
    loadAssets([
      "https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css",
      "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta2/css/all.min.css",
      "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/7.0.1/css/all.min.css",
      "./front/assets/webslidemenu/color-skins/white-gry.css",
      "./front/assets/webslidemenu/webslidemenu.css",
      "./front/assets/webslidemenu/dropdown-effects/fade-down.css",
      "./front/assets/_scss/owl.carousel.min.css",
      "./front/assets/_scss/owl.theme.default.min.css",
      "./front/assets/_scss/main.css",
      "./front/assets/_scss/_custom.css",
      "./front/assets/_scss/_cart.scss",
      "./front/assets/_scss/_product-detail.scss",
      "./front/assets/_scss/_product-list.scss",
      "./front/assets/_scss/login-register.css",
      "./front/assets/_scss/login-register.scss",
      "./front/assets/_scss/_my-profile.scss",
      "./front/assets/_scss/_home.scss",
      "./front/assets/_scss/_new-custom.css",
      "./front/assets/_scss/webslidemenu/dropdown-effects/fade-down.css",

      "https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/js/bootstrap.bundle.min.js",
      "https://cdnjs.cloudflare.com/ajax/libs/jquery/3.7.0/jquery.min.js",
      "./front/assets/_scss/webslidemenu/webslidemenu.js",
      "./front/assets/js/owl.carousel.min.js",
      "./front/assets/js/custom.js",
      "./front/assets/js/custom.js"
    ]);

  }, []);

  return (
    <>
      <ToastContainer position="top-right" autoClose={2000} />
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/index" element={<Home />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/product-list" element={<ProductList />} />
          <Route path="/product/:slug" element={<ProductDetail />} />
          <Route path="/category/:slug" element={<ProductList />} />
          <Route path="/ayush-product-list" element={<ProductList />} />
          <Route path="/category-list" element={<CategoryList />} />
          <Route path="/brand-list" element={<BrandList />} />
          <Route path="/myprofile" element={<Myprofile />} />
          <Route path="/login-register" element={<LoginRegister />} />
          <Route path="/doctor-register" element={<DoctorRegister />} />
          <Route path="/order-success" element={<OrderSuccess />} />
          <Route path="/order-booking-success" element={<OrderBookingSuccess />} />
          <Route path="/privicy-policy" element={<PrivicyPolicy />} />
          <Route path="/cancellation-policy" element={<CancellationPolicy />} />
          <Route path="/terms-condition" element={<TermsCondition />} />
          <Route path="/shipping-policy" element={<ShippingPolicy />} />
          <Route path="/doctor-list-page" element={<FrontDoctorList />} />
          <Route path="/clinic-list-page" element={<FrontClinicList />} />
          <Route path="/clinicdetails/:slug" element={<FrontClinicDetails />} />
          <Route path="/doctordetails/:slug" element={<FrontDoctorDetails />} />
          <Route path="/doctor-booking" element={<FrontDoctorBooking />} />
          <Route path="/booking-confirmed" element={<FrontBookingConfirmed />} />
          <Route path="/treatments" element={<FrontTreatmentList />} />
          <Route path="/treatment/:slug" element={<FrontTreatmentDetails />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/wellness" element={<Wellness />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/health-awareness-calender" element={<HealthAwarenessCalendar  />} />
          <Route path="/calendar" element={<CalendarPage />} />
          <Route path="/event-day" element={<Eventday />} />
          <Route path="/eventDetail/:id" element={<EventDetail />} />

        </Routes>
      </Router>
    </>
  );
}

export default FrontApp;